module.exports = __webpack_public_path__ + "img/ico-user-brand-color.44bbade5.svg";